import React from 'react';
import { connect } from 'react-redux';
import Logger from '../../../../../../common/logger';
import * as CMBActions from '../../actions';
import { CMB_MODE } from '../../types';

import CMBForm from './CMBForm';
import CMBSummary from './CMBSummary';

import './index.scss';

class CMBMaximized extends React.Component {
    constructor(props) {
        super(props);
        CMBActions.setInitMode(props.config);
    }

    filterById(id) {
        return this.props.config.cmbDelayedIntervals.filter(e => e.cmbDelayedIntervalId === id);
    }

    sendEvent() {
        let data = {
            ...this.props.cmbUserData,
            cmbConsentId: this.props.cmbStore.consentId,
            cmbInformationId: this.props.cmbStore.informationId,
            cmbPhoneNumber: this.props.cmbStore.phoneValue
        };

        if (this.props.cmbStore.mode === CMB_MODE.IMMEDIATE) {
            data = {
                ...data,
                cmbImmediateTarget: this.props.config.cmbImmediateTarget
            };
        } else {
            data = {
                ...data,
                cmbDelayedTarget: this.props.config.cmbDelayedTarget,
                cmbDelayedIntervalId: this.props.cmbStore.dateValue
            };
        }

        CMBActions.sendTrackerEvent(this.props.cmbStore.mode, data);
    }

    submit() {
        Logger.log(
            `CMBForm.submit(): [phone='${this.props.cmbStore.phoneValue}',interval='${this.props.cmbStore.dateValue}']`
        );

        this.sendEvent();
        CMBActions.saveSubmittedState();
    }

    render() {
        const { config, cmbUserData, events, cmbStore } = this.props;
        const selectedInterval =
            cmbStore.isFormSubmitted && cmbStore.dateValue != ''
                ? this.filterById(cmbStore.dateValue)
                : config.cmbDelayedIntervals;

        return (
            <div className="cmb-maximized">
                {cmbStore.isFormSubmitted === false ? (
                    <CMBForm
                        config={config}
                        cmbUserData={cmbUserData}
                        events={events}
                        onSubmit={() => this.submit()}
                    />
                ) : (
                    <CMBSummary
                        cmbImmediateCountdown={config.cmbImmediateCountdown}
                        cmbMode={cmbStore.mode}
                        cmbDelayedIntervalDay={
                            selectedInterval ? selectedInterval[0].cmbDelayedIntervalDay : null
                        }
                        cmbDelayedIntervalHour={
                            selectedInterval ? selectedInterval[0].cmbDelayedIntervalHour : null
                        }
                        events={events}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        cmbStore: state.cmb
    };
};

export default connect(mapStateToProps)(CMBMaximized);
